"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataConnectionTooltipComponentContent = exports.DataConnectionTooltipComponent = exports.dataConnectionTooltipTestId = void 0;
var React = require("react");
var Style_1 = require("../common/Style");
var widgets_1 = require("@tableau/widgets");
var DataConnectionIcon_1 = require("./DataConnectionIcon");
var DataConnectionList_1 = require("./DataConnectionList");
var Id_1 = require("../common/Id");
var Localize_1 = require("../../gen-src/Localize");
// Extra space between certification icon and other in-line content
var space = 4;
var contentStyle = __assign(__assign({}, Style_1.tooltipStyle), { marginTop: space, marginBottom: space, marginRight: space, marginLeft: -1 * space });
var dataConnectionIconStyle = {
    verticalAlign: 'text-bottom'
};
var contentHeaderStyle = {
    fontWeight: 'bold',
    marginLeft: Style_1.certificationIconSize
};
var contentFooterStyle = {
    textAlign: 'right'
};
var linkStyle = {
    color: '2A79AF'
};
/**
 * Test id attribute value (prefix) for content of data connection tooltip component.
 */
exports.dataConnectionTooltipTestId = 'data-connection-tooltip';
/**
 * Data connection tooltip component.
 * @param props - The props for this data connection tooltip.
 */
function DataConnectionTooltipComponent(props) {
    // NOTE this function could make an AJAX request
    var getContent = function () { return Promise.resolve(React.createElement(DataConnectionTooltipComponentContent, __assign({}, props))); };
    return (React.createElement("span", null,
        React.createElement(widgets_1.ChromeTooltipWidget, { getContent: getContent, width: Style_1.tooltipSize, defaultSide: 'Bottom', boundaryElement: props.boundaryElement, zIndex: props.zIndex },
            React.createElement(DataConnectionIcon_1.DataConnectionIconComponent, { style: dataConnectionIconStyle, id: props.id })),
        props.label || props.dataConnections.length));
}
exports.DataConnectionTooltipComponent = DataConnectionTooltipComponent;
function DataConnectionTooltipComponentContent(_a) {
    var dataConnections = _a.dataConnections, url = _a.url, id = _a.id;
    return (React.createElement("div", { "data-tb-test-id": (0, Id_1.generateId)(exports.dataConnectionTooltipTestId, id), style: contentStyle },
        dataConnections.length === 0 &&
            React.createElement("span", { style: contentHeaderStyle }, Localize_1.Messages.NoDataConnections()),
        React.createElement(DataConnectionList_1.DataConnectionListComponent, { dataConnections: dataConnections }),
        React.createElement("div", { style: contentFooterStyle },
            React.createElement("a", { style: linkStyle, href: url }, Localize_1.Messages.SeeMoreDetails()))));
}
exports.DataConnectionTooltipComponentContent = DataConnectionTooltipComponentContent;
//# sourceMappingURL=DataConnectionTooltip.js.map